// src/components/FloorplanSection.jsx
import React, { useEffect } from "react";
import "./FloorplanSection.css";
import { FaExpandArrowsAlt, FaBed, FaBath, FaCar } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

export default function FloorplanSection() {
    const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;

  const rooms = [
    // { name: 'Swimming Pool', size: '20 m²', highlighted: true },\
    { name: "Swimming Pool", highlighted: true },
    { name: "Kids Play Area" },
    { name: "Elder Park", highlighted: true },
    { name: "Water Fountain" },
    { name: "Interactive Water ", highlighted: true },
    { name: "Open Air Theatre",},
    { name: "Topiary Gardens" , highlighted: true },
    { name: "Ceremonial Lawn"},
    { name: "Clubhouse", highlighted: true },
    { name: "Basketball Court" },
    { name: "Badminton Court", highlighted: true },
    { name: "Cricket Pitch" },
    { name: " Fire Place ", highlighted: true },
    { name: "Pergola" },
    { name: "Pavilion", highlighted: true },
    { name: "Reflecology Path" },
    { name: "Pet Park", highlighted: true },
  ];

  const stats = [
    { title: "32 Acre Township", value: "Size" },
    { title: "120-180SQYD", value: "Plot Size" },
    { title: "30+", value: "Amenities" },
    { title: " 1st Rera Approved ", value: " Plotted Township Project" },
    // { title: 'Township Project',    icon: <FaCar />,            value: 'Its Rera Approved Plotted'          }
  ];
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: false, // animation only once on scroll
    });
  }, []);

  return (
    <section id="section-floorplan" className="section-floorplan">
      <div className="container">
        <div
          className="grinei row align-items-center g-4"
          data-aos="fade-up"
          data-aos-duration="3000"
        >
          <div className="col-lg-4 lokii">
            <div className="content-wrap">
              <span className="subtitle">Site Map</span>
              <h2>Master Plan</h2>
              <p>
                Aanandam Valleey offers world  class amenities for a premium lifestyle. connecting your spiritual self to the modern comforts
              </p>

              <div className="room-list">
                {rooms.map((r, i) => (
                  <div
                    key={i}
                    className={`room-item d-flex justify-content-between px-4 py-2 ${
                      r.highlighted ? "highlighted" : ""
                    }`}
                  >
                    <span>{r.name}</span>
                    <strong>{r.size}</strong>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className="col-lg-8"
            data-aos="fade-down"
            data-aos-duration="3000"
          >
            <div className="floorplan-carousel">
              <img
                src={`${IMAGE_BASE_URL}/floorpalan.png`}
                alt="Floorplan"
                className="img-fluid floorplan-image"
              />
            </div>
          </div>
        </div>

        <div className="row stats-row g-3 mt-5">
          {stats.map((s, i) => (
            <div className="col-md-3 col-12" key={i}>
              <div className="stat-card text-center p-4" data-aos="zoom-in">
                <h4>{s.title}</h4>
                <div className="d-flex justify-content-center align-items-center mt-2">
                  <span className="stat-icon me-2">{s.icon}</span>
                  <span>{s.value}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
